import { PlaylistType } from "../AddToPlaylistModal";
import { ListItem } from "../list-item/ListItem";
import { StyledListContainer } from "./StyledComponents";
import { translate } from "@kaltura/mediaspace-shared-utils";

interface PlaylistsListProps {
    /** Playlists to render */
    playlists?: PlaylistType[];
    /** Callback when a playlist's state changes */
    onChange: (id: string, isChecked: boolean) => void;
    /** ID for the list container (for aria-controls) */
    listId?: string;
}

export const PlaylistsList = (props: PlaylistsListProps) => {
    const { playlists, onChange, listId } = props;
    const totalCount = playlists?.length ?? 0;

    return (
        <StyledListContainer id={listId} role="list" aria-label={translate("Playlists")}>
            {playlists?.map((playlist: PlaylistType, index: number) => (
                <ListItem
                    key={playlist.id}
                    name={playlist.name}
                    id={playlist.id}
                    isAdded={playlist.isSelected}
                    onChange={onChange}
                    position={index + 1}
                    totalCount={totalCount}
                />
            ))}
        </StyledListContainer>
    );
};
